import React from 'react';

export default function Features() {
const features = [
  {
      title: "Enerji Panoları İzleme",
      description: "Enerji panolarınızı gerçek zamanlı olarak izleyin, detaylı analizler yapın ve enerji tüketiminizi optimize edin. Akıllı izleme sistemimiz ile tüm panolarınızı tek bir platformdan yönetin.",
      image: "/features/energy-monitoring.svg",
      imagePosition: "right"
    },
    {
      title: "Yapay Zeka Ges Üretim Tahmini",
      description: "Yapay zeka algoritmalarımız ile güneş enerjisi santrallerinizin üretim tahminlerini yüksek doğrulukla hesaplayın. Hava durumu verilerini ve geçmiş üretim verilerinizi kullanarak geleceğe yönelik üretim planlaması yapın.",
      image: "/features/ai-prediction.svg",
      imagePosition: "left"
    },
    {
      title: "PV Bazlı Panel Verimlilik İzleme",
      description: "Güneş panellerinizin performansını panel bazında takip edin. Verimliliği düşen panelleri tespit edin ve bakım planlamanızı optimize edin.",
      image: "/features/pv-monitoring.svg",
      imagePosition: "right"
    },
    {
      title: "IoT Endüstri 4.0",
      description: "Endüstri 4.0 standartlarına uygun IoT cihazlarımız ile tesisinizi geleceğe taşıyın. Akıllı sensörler ve gerçek zamanlı veri analizi ile üretim süreçlerinizi optimize edin.",
      image: "/features/iot-industry.svg",
      imagePosition: "left"
    },
    {
      title: "Osos İzleme",
      description: "Otomatik Sayaç Okuma Sistemlerinizi (OSOS) tek bir platformdan izleyin ve yönetin. Tüketim verilerinizi otomatik olarak toplayın ve raporlayın.",
      image: "/features/osos-monitoring.svg",
      imagePosition: "right"
    },
    {
      title: "Kompanzasyon Takibi",
      description: "Reaktif enerji tüketiminizi kontrol altında tutun. Kompanzasyon sistemlerinizi gerçek zamanlı izleyin ve ceza ödemekten kaçının.",
      image: "/features/compensation-tracking.svg",
      imagePosition: "left"
    },
    {
      title: "Fatura Hesaplama",
      description: "Enerji tüketim verilerinizi kullanarak fatura tahminlerinizi otomatik olarak hesaplayın. Bütçe planlamanızı daha doğru yapın.",
      image: "/features/billing-calculation.svg",
      imagePosition: "right"
    },
    {
      title: "Alarm Kuralları Oluşturma",
      description: "Özelleştirilebilir alarm kuralları ile sistemlerinizi 7/24 izleyin. Kritik durumları anında tespit edin ve hızlıca müdahale edin.",
      image: "/features/alarm-rules.svg",
      imagePosition: "left"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-white via-[var(--color-background)] to-white">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl font-bold text-center text-[var(--color-primary)] mb-16">
          Solar Tools Özellikleri
        </h2>

        <div className="space-y-24">
          {features.map((feature, index) => (
            <div 
              key={index}
              className={`flex flex-col ${feature.imagePosition === 'left' ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center`}
            >
              {/* Metin Bölümü */}
              <div className="flex-1 text-left px-8 lg:px-16">
                <h3 className="text-2xl font-bold text-[var(--color-primary)] mb-4">
                {feature.title}
              </h3>
                <p className="text-lg text-[var(--color-black)] leading-relaxed">
                  {feature.description}
                </p>
            </div>

              {/* Görsel Bölümü */}
              <div className="flex-1">
                <div className="relative bg-white overflow-hidden">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-auto"
                  />
                  {/* Parlaklık efekti */}
                  <div 
                    className="absolute inset-0 pointer-events-none"
                    style={{
                      background: 'linear-gradient(105deg, transparent 20%, rgba(255,255,255,0.2) 50%, transparent 80%)',
                    }}
                  />
            </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 